module.exports = __webpack_public_path__ + "img/dis-feibanzu.267b8a81.svg";